// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLOSE_WINDOW = "Zavri";
export const PRIVACY_LEAFLET_MORE_INFO = "Viac inform\u00e1ci\u00ed tu.";
export const PRIVACY_LEAFLET_ONE_LINER = "Pou\u017e\u00edvame cookies.";
